
import httpClient from "../Core/http";

class SupportCasesAPi {
  getCustomerSupportCases(params: any): Promise<any> {
    let url = "SupportCases2/customer";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
  getSupportCaseTypes(): Promise<any> {
    let url = "SupportCases2/types";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url)
        .then((response: any) => {
          resolve(response.data.issueTypes);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
  getMachineSupportCases(params: any): Promise<any> {
    let url = "SupportCases2/machine";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
  getIssueMetaData(params: any): Promise<any> {
    let url = "SupportCases2/issueMetaData";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
  getIssueMachineData(params: any): Promise<any> {
    let url = "SupportCases2/machineInfo";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
  getSerialsByMachine(params: any): Promise<any> {
    let url = "Machine/deviceSerialsByMachine";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
  getUserList(): Promise<any> {
    let url = "SupportCases2/userList";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url)
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
  saveIssue(params: any): Promise<any> {
    let url = "SupportCases2/saveIssue";
    return new Promise((resolve, reject) => {
      httpClient
        .post<any[]>(url, { params: params })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
}

export const SupportCasesApi = new SupportCasesAPi();
